const styles = theme => ({
  WrapperSearch: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start', 
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 8px',
  },
  containerBack: {
    width: '100%',
    maxWidth: 1200,
    margin: '0 auto',
    padding: '16px 8px 0',
    display: 'flex',
    alignItems: 'baseline',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  button: {
    textTransform: 'initial'
  },
  leftIcon: {
    width: '.75em',
    height: '.75em',
    marginRight: '5px'
  },
  appSearch: {
    flexShrink: 'unset',
  },
  search: {
    width: 'auto',
    pointerEvents: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 10px 0 10px',
    color: '#424242'
  },
  inputSearch: {
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    padding: 0,
    minHeight: 40,
    height: 40,
    position: 'relative',
    border: '1px solid',
    borderColor: '#C8C8C8',
    borderRight: 'none !important'
  },
  wrapperForm: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  contentFilters: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    '@media (max-width: 386px)': {
      flexDirection: 'column',
    },
  },
  contentNull: {
    height: "auto"
  },
  filtroBtn: {
    height: 40,
    backgroundColor: '#FFFFFF',
    border: '1px solid',
    borderColor: '#C8C8C8',
    minWidth: 100,
    textTransform: 'initial',
    fles: 1,
    '& svg': {
      marginRight: 10,
    }
  },
  filtroIconBtn: {
    height: 40,
    width: 40,
    backgroundColor: '#FFFFFF',
    border: '1px solid',
    borderColor: '#C8C8C8',
    maxWidth: 40,
    minWidth: 40,
    maxHeight: 40,
    borderRadius: 4
  },
  contentRange: {
    padding: 0,
    position: 'relative',
    zIndex: 1101,
    display: 'flex',
    border: '1px solid',
    borderColor: '#C8C8C8',
    borderRadius: 4,
    minHeight: 40,
    height: 40,
    minWidth: 315,
    flex: 1,
    [theme.breakpoints.down('xs')]: {
      minWidth: 260,
    },
  },
  input: {
    font: 'inherit',
    // padding: `0 ${theme.spacing.unit}px 0 ${theme.spacing.unit}px`,
    border: 0,
    display: 'block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    height: 40,
    margin: 0, // Reset for Safari
    color: 'inherit',
    width: '100%',
    '& input': {
      paddingRight: '10px !important'
    },
    '&:focus': {
      outline: 0,
    },
    '&:before': {
      border: 'none !important'
    },
    '&:after': {
      border: 'none !important'
    }
  },
  inputDate: {
    font: 'inherit',
    // padding: `0 ${theme.spacing.unit}px 0 ${theme.spacing.unit}px`,
    border: 0,
    display: 'block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    margin: 0, // Reset for Safari
    color: 'inherit',
    width: '100%',
    '& input': {
      border: '0 !important'
    },
    '&:focus': {
      outline: 0,
    },
    '& > div': {
      height: 40,
      width: '100%',
      border: 'none !important',
      '&:before': {
        border: 'none !important'
      },
      '&:after': {
        border: 'none !important'
      }
    }
  },
  inputDateMobile: {
    maxWidth: 223,
  },
  drawerHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 1}px 0`,
    position: 'sticky',
    top: 0,
    background: 'white',
    zIndex: 999999,
  },
  titleFil: {
    margin: `0 0 0 ${theme.spacing.unit * 3}px`,
    position: 'relative',
    textTransform: 'capitalize',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: 40,
    }
  },
  fixedTitle: {
    width: '100%',
    padding: '0 24px 15px 0',
    backgroundColor: '#ffffff',
    position: 'sticky',
    top: 0,
    right: 0,
    zIndex: 3000,
    '& h5': {
      display: 'inline-block !important',
    }
  },
  filterForm: {
    padding: theme.spacing.unit * 3
  },
  filterContainer: {
    minWidth: '317px'
  },
  // Estilos para cards

  item: {
    textAlign: 'left',
    '& img': {
      margin: '10px auto'
    }
  },
  itemPortada: {
    display: 'flex !important',
    justifyContent: 'center !important',
    //   '& img': {
    //     margin: '10px auto'
    //   }
  },
  color1: {
    color: theme.palette.primary.main,
  },
  bgColor1: {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  titleCartoon: {
    fontSize: 18,
    height: 20,
    overflow: 'hidden',
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginBottom: 5,
  },
  titleRadio: {
    fontSize: 18,
    // height: 30,
    overflow: 'hidden',
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': '1',
    '-webkit-box-orient': 'vertical',
    color: '#000',
    fontWeight: 500,
  },
  title: {
    fontSize: 18,
    // height: 57,
    overflow: 'hidden',
    display: '-webkit-box',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    color: '#000',
    fontWeight: 500,
    marginBottom: 5,
  },
  description: {
    color: '#000',
    minHeight: 82,
    // maxHeight: 82,
    // overflow: 'hidden'
  },
  wraper: {
    maxHeight: 'none !important'
  },
  count: {
    backgroundColor: theme.palette.primary.main,
    padding: '0px 10px',
    color: 'white !important',
    fontSize: 12,
    maxHeight: 20,
    borderRadius: 15
  },
  checkFilterInput: {
    '& + label::before': {
      minWidth: '16px !important',
      border: '1px solid #000000 !important',
      backgroundColor: 'transparent !important'
    },
    '&:checked + label::before': {
      backgroundColor: `${theme.palette.primary.main} !important`,
      borderColor: `${theme.palette.primary.main} !important`,
    }
  },
  checkFilterLabel: {
    color: 'rgba(0, 0, 0, 0.87) !important'
  },
  suggestionWrapper: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    marginTop: 4,
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1400,
    maxHeight: 320,
    overflowY: 'auto',
    padding: '4px 0'
  },
  suggestionGroupLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: '#757575',
    textTransform: 'uppercase',
    letterSpacing: .4,
    padding: '6px 16px'
  },
  suggestionItem: {
    padding: '8px 16px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  suggestionItemActive: {
    backgroundColor: '#F0F0F0'
  },
  suggestionTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: '#212121'
  },
  suggestionSubtitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#212121'
  },
  suggestionDescription: {
    fontSize: 12,
    color: '#616161',
    lineHeight: 1.4,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  columnistSuggestion: {
    '& $suggestionTitle': {
      color: theme.palette.primary.main
    }
  },
  inlineSuggestionContainer: {
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
    marginTop: 8,
    border: '1px solid #E0E0E0',
    overflow: 'hidden'
  },
  inlineSuggestionItem: {
    background: 'none',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    padding: 0,
    '&:hover': {
      backgroundColor: '#F0F0F0'
    }
  },
  highlightText: {
    fontWeight: 800,
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  paginationHidden: {
    display: 'none',
  },
  numbersBtns: {
    padding: '0px 0px',
    minWidth: '36px !important'
  },

});

export default styles;
